import moment from "moment";

export function defaultCampanhaComercial() {
  return {
    id: null,
    erpId: null,
    descricao: "",
    funcionamento: "",
    dataInicio: moment().format(),
    dataFim: moment().add(1, "days").format(),
    qtdeMin: 0,
    qtdeMax: null,
    qtdeMinDistinta: 0,
    qtdeMaxDistinta: null,
    vlMin: 0,
    vlMax: 0,
    percMin: 0,
    percMax: 0,
    validarTodasRegras: false,
    validarPorRegra: false,
    consideraQtdeEstoque: false,
    aplicarSobrePromocao: false,
    aplicarSobreNegociacao: false,
    validaSobrePromocao: false,
    acumulaDesconto: false,
    usaNaoCompra: false,
    tipo: "SEGMENTACAO",
    validacao: "QT",
    brindes: [],
    dimensoes: [],
    mixProdutos: [],
    restricoes: [],
    aplicacallcenter: false,
    aplicab2b: false,
    aplicafv: false,
  };
}

export function cloneCampanhaParaCriacao(campanha) {
  return {
    ...campanha,
    id: null,
    erpId: null,
    descricao: `Cópia de ${campanha.descricao}`,
    brindes: campanha.brindes ? [...campanha.brindes] : [],
    dimensoes: campanha.dimensoes ? [...campanha.dimensoes] : [],
    mixProdutos: campanha.mixProdutos ? [...campanha.mixProdutos] : [],
    restricoes: campanha.restricoes ? [...campanha.restricoes] : [],
  };
}

export function normalizeCampanhaParaApi(item) {
  const normalized = { ...item };
  normalized.dataInicio = item.dataInicio
    ? moment(item.dataInicio).format("YYYY-MM-DD")
    : null;
  normalized.dataFim = item.dataFim
    ? moment(item.dataFim).format("YYYY-MM-DD")
    : null;
  normalized.brinde = Array.isArray(item.brindes) && item.brindes.length > 0;
  return normalized;
}
